import React, { useEffect, useState } from 'react'
import { Box, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, List, ListItem, Divider, Grid } from '@mui/material'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { useQuery } from '@tanstack/react-query';
import { getNpoFinanceDetails } from '../../../Store/npoProfile/npoProfile';
import userIcon from '../../../Assets/img/user_icon.png';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import Loading from '../../../Components/Loader/Loading';
ChartJS.register(ArcElement, Tooltip, Legend);
export default function Financial({ orgName, id }) {

  const { data: financialDetails, isPending: financialDetailsLoading } = useQuery({
    queryKey: ['financialDetails', orgName],
    queryFn: () => getNpoFinanceDetails(orgName),
    refetchOnWindowFocus: false,
    enabled: !!orgName
  });

  //Sale Chart Data
  const [categoriesData, setCategoriesData] = useState([]);
  const [seriesData, setSeriesData] = useState([{ data: [] }]);
  const filteredData = (seriesData?.data || []).map((value, index) => {
    const label = categoriesData?.[index];
    return label ? { label, value } : null;
  }).filter(Boolean); // Remove nulls
  useEffect(() => {
    const fundingDetails = financialDetails?.sources_of_funding || [];

    if (fundingDetails?.length > 0) {
      // Initialize arrays to store extracted data
      const donorCategory = [];
      const fundDetails = [];
      const donorDetails = [];

      // Single iteration to extract all required data
      fundingDetails?.forEach((item) => {
        donorCategory?.push(item?.donor_category);
        fundDetails?.push(Number(item?.total_fund_raised || 0));
        donorDetails?.push(Number(item?.no_of_donors || 0));
      });

      // Update state with extracted data
      setCategoriesData(donorCategory);
      setSeriesData({ name: 'Total Funds', data: fundDetails });
    } else {
      setSeriesData();
    }
  }, [financialDetails]);
  
  const data = {
    labels: filteredData?.map(item => item.label),
    datasets: [
      {
        label: seriesData?.name || 'Dataset',
        data: filteredData?.map(item => item.value),
        backgroundColor: [
          '#95dcf7' , '#ff9600' , '#febd00' ,
          '#3a7d22' , '#8ed873' , '#215e99' ,
          '#4d94d8' , '#78206e' , '#d76dcc' ,
          '#ff48f6' , '#f1ceee' , '#1ABC9C' ,
          '#2ECC71' , '#E74C3C' , '#9B59B6' , '#34495E'
        ],
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };
  // const ChartOptions = {
  //   plotOptions: {
  //     bar: {
  //       horizontal: false,
  //       columnWidth: '110%',
  //       dataLabels: {
  //         position: 'top',
  //       },
  //     },
  //   },
  //   chart: {
  //     type: 'bar',
  //     height: 600,
  //     toolbar: {
  //       show: false,
  //     },
  //   },
  //   grid: {
  //     show: true,
  //   },
  //   dataLabels: {
  //     enabled: true,
  //     offsetY: -20,
  //     style: {
  //       fontSize: '10px',
  //       colors: ['#304758'],
  //     },
  //   },
  //   stroke: {
  //     show: true,
  //     colors: ['transparent'],
  //   },
  //   labels: ['Total Funds Raised in the FY'],
  //   xaxis: {
  //     type: 'category',
  //     categories: categoriesData || [], // Ensure this is an array
  //     labels: {
  //       show: false,
  //     },
  //   },
  //   yaxis: {
  //     labels: {
  //       show: false,
  //     },
  //   },
  //   colors: ['#ED1C24', '#004878'],
  //   theme: {
  //     mode: 'light',
  //   },
  //   tooltip: {
  //     fixed: {
  //       enabled: true,
  //     },
  //     x: {
  //       show: true,
  //     },
  //     marker: {
  //       show: false,
  //     },
  //   },
  //   title: {
  //     text: 'Total Funds Raised in the FY',
  //     floating: false,
  //     align: 'center',
  //     style: {
  //       color: '#444',
  //     },
  //   },
  // };



  const formatCurrency = (value) => {
    if (isNaN(value)) return '-'; // Handle invalid or null values
    return new Intl.NumberFormat('en-IN', {
      // style: 'currency',
      currency: 'INR', // Change to your desired currency code
      minimumFractionDigits: 2,
    }).format(value);
  };
  const parseDate = (dateString) => {
    if (!dateString) return new Date(0); // Default to a very old date if the string is invalid
    const [day, month, year] = dateString.split('-');
    return new Date(`${year}-${month}-${day}`);
  };
  const assetDetails = financialDetails?.financials?.[0]?.assets || '';
  const liabilitiesDetails = financialDetails?.financials?.[1]?.liabilities || '';
  const incomeDetails = financialDetails?.financials?.[2]?.income || '';
  const expenseDetails = financialDetails?.financials?.[3]?.expenditure || '';
  const receiptDetails = financialDetails?.financials?.[4]?.receipts || '';
  const paymentDetails = financialDetails?.financials?.[5]?.payments || '';

  return (
    <>

      <div id={id} >
        <Divider sx={{ color: '#E5E8EB', marginTop: '15px', borderBottomWidth: 3 }} />
        <Grid container spacing={2} sx={{ mt: .5 }}>
          <Grid item xs={6}>
            <Box sx={{ backgroundColor: '#004878', padding: '10px', borderRadius: '15px', width: '100%', display: 'flex', alignItems: 'center' }}>
              <ParagraphComp text='Financials' className='text-[white] mt-[0px] mb-[0px] text-2xl  font-bold' />
            </Box>
          </Grid>
        </Grid>

        {
          assetDetails ||
            liabilitiesDetails ||
            incomeDetails ||
            expenseDetails ||
            receiptDetails ||
            paymentDetails ||
            financialDetails?.top_donors?.length > 0 ||
            financialDetails?.financials?.[6]?.income_tax_return ||
            financialDetails?.financials?.[7]?.fcra_return ||
            financialDetails?.sources_of_funding?.length > 0
            ?

            <>
            
              <Grid container spacing={2} sx={{ mt: .5 }}>
                <Grid item xs={6}>
                </Grid>
                <Grid item xs={6}>
                  <ParagraphComp text='Last updated on:' className='text-[black] italic font-thin' />
                </Grid>
              </Grid>
              {financialDetailsLoading ? <Box sx={{ mt: 5, px: 4, display: 'flex', justifyContent: 'center' }}><Loading /></Box> : <Box sx={{ mt: 3 }}>
                {seriesData &&<ParagraphComp text='Source of Funding' className='text-[#004878] text-2xl mb-3 font-bold' />}
                {seriesData &&<ParagraphComp text='ˇ SOURCE: Self-reported by organisation' className='text-[black] text-md mb-[10px] italic font-thin' />}
                {/* <Chart
                  options={ChartOptions}
                  series={seriesData}
                  type="bar"
                  height="500"
                /> */}
                {seriesData && <div className='flex justify-between'>
                  {seriesData?.data?.length > 0 &&
                    <div style={{ width: '50%', height: '600px' }}>
                      <Pie data={data} options={{ maintainAspectRatio: false }} />
                    </div>
                  }

                  <Box sx={{ mt: 2 , width:'40%'}}>
                    <Table aria-label="Source of Funding table">
                      <TableHead sx={{ background: '#EDF2F6', fontSize: '20px' }}>
                        <TableRow>
                          <TableCell
                            sx={{
                              color: '#004878',
                              fontWeight: 600,
                              fontSize: '16px',
                            }}
                            align="left"
                          >
                            Source of Funding
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#004878',
                              fontWeight: 600,
                              fontSize: '16px',
                              textAlign: 'end'
                            }}
                            align="left"
                          >
                            Amount (₹)
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#004878',
                              fontWeight: 600,
                              fontSize: '16px',
                              textAlign: 'end'
                            }}
                            align="left"
                          >
                            Percentage
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredData.map((row) => {
                          const total = filteredData.reduce((sum, item) => sum + item.value, 0);
                          const percentage = total > 0 ? ((row.value / total) * 100).toFixed(2) + '%' : '0%';
                          
                          return (
                            <TableRow key={row.label}>
                              <TableCell
                                sx={{ fontSize: '14px' }}
                                align="left"
                              >
                                {row.label}
                              </TableCell>
                              <TableCell
                                sx={{ fontSize: '14px', textAlign: 'end' }}
                                align="left"
                              >
                                {row.value.toLocaleString('en-IN')}
                              </TableCell>
                              <TableCell
                                sx={{ fontSize: '14px', textAlign: 'end' }}
                                align="left"
                              >
                                {percentage}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                        
                      </TableBody>
                    </Table>
                  </Box>
                </div>}
                
                {financialDetails?.top_donors?.length > 0 &&
                  <>
                    <ParagraphComp text='Top Donors' className='text-[#004878] text-2xl font-bold' />
                    <Grid container xs={12} spacing={2} sx={{ mt: '10px' }} className='w-full inline-flex flex-nowrap' >
                      {financialDetails?.top_donors?.map((item, index) => (
                        <Grid xs={3} key={index} className='' item >
                          <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '0px', paddingLeft: '0px' }}>
                            <ParagraphComp className='  text-[#004878]'>{`${index + 1}. ${item?.donor_name || '-'}`}</ParagraphComp>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>

                  </>
                }

                <ParagraphComp text='Financials' className='text-[#000000] mt-[10px] mb-[0px] text-2xl  font-bold' />
                <ParagraphComp text='ˇ SOURCE: Self-reported by organisation ' className='text-[black] text-md mt-[10px] mb-[5px] italic font-thin' />
                <Box sx={{ mt: 2 }}>
                  <ParagraphComp text='Balance Sheet (all figures are in ₹)' className='text-[#004878] text-2xl mb-3 font-bold' />
                  <Table aria-label="collapsible table">
                    <TableHead sx={{ background: '#EDF2F6', fontSize: '20px' }}>
                      <TableRow>

                        <TableCell
                          sx={{
                            color: '#004878',
                            fontWeight: 600,
                            fontSize: '16px',
                          }}
                          align="left"
                        >
                          Liabilities as on
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#004878',
                            fontWeight: 600,
                            background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                              ? '#EDF2F6'
                              : 'inherit',
                            fontSize: '16px',
                            textAlign: 'end'
                          }}
                          align="left"
                        >
                          {liabilitiesDetails?.liability_date1 || '-'}
                          <span> (₹)</span>
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#004878',
                            fontWeight: 600,
                            background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                              ? '#EDF2F6'
                              : 'inherit',
                            fontSize: '16px',
                            textAlign: 'end'
                          }}
                          align="left"
                        >
                          {liabilitiesDetails?.liability_date2 || '-'}
                          <span> (₹)</span>
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#004878',
                            fontWeight: 600,
                            fontSize: '16px',
                          }}
                          align="left"
                        >
                          Assets as on
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#004878',
                            fontWeight: 600,
                            background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                              ? '#EDF2F6'
                              : 'inherit',
                            fontSize: '16px',
                            textAlign: 'end'

                          }}
                          align="left"
                        >
                          {assetDetails?.asset_date1 || '-'}
                          <p>₹</p>
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#004878',
                            fontWeight: 600,
                            background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                              ? '#EDF2F6'
                              : 'inherit',
                            fontSize: '16px',
                            textAlign: 'end'
                          }}
                          align="left"
                        >
                          {assetDetails?.asset_date2 || '-'}
                          <p>₹</p>
                        </TableCell>
                      </TableRow>


                    </TableHead>
                    <TableBody>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Trust/ Society/ Share-holder funds</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background:
                            parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                              ? '#EDF2F6'
                              : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.trust1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.trust2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Fixed Assets</TableCell>
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px'
                        }} align="right">{formatCurrency(assetDetails?.fixed_asset1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(assetDetails?.fixed_asset2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">General fund (unrestricted fund)</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.general_fund1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.general_fund2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Investments</TableCell>
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(assetDetails?.investments1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(assetDetails?.investments2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Corpus and endowment fund(s)</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.corpus1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.corpus2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Loans and advances</TableCell>
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(assetDetails?.loan_and_advances1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(assetDetails?.loan_and_advances2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Restricted/ Earmarked funds </TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.restricted1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.restricted2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Cash and bank balances</TableCell>
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(assetDetails?.cash_and_bank1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(assetDetails?.cash_and_bank2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Grant balances</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.grant_balance1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.grant_balance2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Other current assets</TableCell>
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(assetDetails?.other_current_assets1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(assetDetails?.other_current_assets2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Loans and borrowings</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.loans1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.loans2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Excess of expenditure over income (if any)</TableCell>
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(assetDetails?.excess_of_expenditure1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(assetDetails?.excess_of_expenditure2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Current liabilities and provisions</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.current_liabilities1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.current_liabilities2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" />
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="left" />
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="left" />

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Excess of income over expenditure</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.excess_of_income1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.excess_of_income2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" />
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="left" />
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="left" />

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px', fontSize: '16px', fontWeight: '600' }} align="left" >Total Liabilities</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date1) > parseDate(liabilitiesDetails?.liability_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(liabilitiesDetails?.total_liabilities1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(liabilitiesDetails?.liability_date2) > parseDate(liabilitiesDetails?.liability_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          fontSize: '16px',
                        }} align="right">{formatCurrency(liabilitiesDetails?.total_liabilities2 || '-')}</TableCell>
                        <TableCell align="left" sx={{ color: 'black', fontWeight: 600, fontSize: '16px' }}>Total Assets</TableCell>
                        <TableCell sx={{
                          background: parseDate(assetDetails?.asset_date1) > parseDate(assetDetails?.asset_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(assetDetails?.total_assets1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(assetDetails?.asset_date2) > parseDate(assetDetails?.asset_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(assetDetails?.total_assets2 || '-')}</TableCell>

                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
                <Box sx={{ mt: 2.5 }}>
                  <ParagraphComp text='Income and Expenditure Statement (all figures are in ₹)' className='text-[#004878] text-2xl mb-3 font-bold' />
                  <Table aria-label="collapsible table">
                    <TableHead sx={{ background: '#EDF2F6' }}>
                      <TableRow>

                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Expenditure for the year ended on</TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="right">{expenseDetails?.exp_date1}  <span> (₹)</span></TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="right">{expenseDetails?.exp_date2}  <span> (₹)</span></TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Income for the year ended on</TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px', background: '#EDF2F6' }} align="right">{incomeDetails?.inc_date1} <span> (₹)</span></TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="right">{incomeDetails?.inc_date2}  <span> (₹)</span></TableCell>

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Programme</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date1) > parseDate(expenseDetails?.exp_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.programme1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date2) > parseDate(expenseDetails?.exp_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.programme2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Earned/ Self-generated income from programmes</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) > parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(incomeDetails?.earned_income1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) < parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(incomeDetails?.earned_income2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Public education and fundraising</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date1) > parseDate(expenseDetails?.exp_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.public_education1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date2) > parseDate(expenseDetails?.exp_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.public_education2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Donations from Indian sources</TableCell>
                        <TableCell sx={{
                          background: parseDate(incomeDetails?.inc_date1) > parseDate(incomeDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(incomeDetails?.donations_indian1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) < parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(incomeDetails?.donations_indian2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Management and administration</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date1) > parseDate(expenseDetails?.exp_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.management1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date2) > parseDate(expenseDetails?.exp_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.management2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Grants from Indian sources</TableCell>
                        <TableCell sx={{
                          background: parseDate(incomeDetails?.inc_date1) > parseDate(incomeDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(incomeDetails?.grants_indian1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) < parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(incomeDetails?.grants_indian2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Payments to beneficiaries/ communities</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date1) > parseDate(expenseDetails?.exp_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.payments1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date2) > parseDate(expenseDetails?.exp_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.payments2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Donations from International sources</TableCell>
                        <TableCell sx={{
                          background: parseDate(incomeDetails?.inc_date1) > parseDate(incomeDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(incomeDetails?.donations_international1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) < parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(incomeDetails?.donations_international2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left">Other expenses</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date1) > parseDate(expenseDetails?.exp_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.other_exp1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date2) > parseDate(expenseDetails?.exp_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.other_exp2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Grants from International sources</TableCell>
                        <TableCell sx={{
                          background: parseDate(incomeDetails?.inc_date1) > parseDate(incomeDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(incomeDetails?.grants_international1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) < parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(incomeDetails?.grants_international2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell sx={{ fontSize: '16px' }} align="left"></TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date1) > parseDate(expenseDetails?.exp_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.loans1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date2) > parseDate(expenseDetails?.exp_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.loans2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left">Other income (including interest)</TableCell>
                        <TableCell sx={{
                          background: parseDate(incomeDetails?.inc_date1) > parseDate(incomeDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(incomeDetails?.other_income1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) < parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(incomeDetails?.other_income2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell align="left" sx={{ color: 'black', fontWeight: 600, fontSize: '16px' }}>Total Expenditure</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date1) > parseDate(expenseDetails?.exp_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.total_exp1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date2) > parseDate(expenseDetails?.exp_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.total_exp2 || '-')}</TableCell>
                        <TableCell align="left" sx={{ color: 'black', fontWeight: 600, fontSize: '16px' }}>Total Income</TableCell>
                        <TableCell sx={{
                          background: parseDate(incomeDetails?.inc_date1) > parseDate(incomeDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right">{formatCurrency(incomeDetails?.total_income1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) < parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(incomeDetails?.total_income2 || '-')}</TableCell>

                      </TableRow>
                      <TableRow>

                        <TableCell align="left" sx={{ color: 'black', fontWeight: 600, fontSize: '16px' }}>Surplus/(Deficit)</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date1) > parseDate(expenseDetails?.exp_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.surplus1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(expenseDetails?.exp_date2) > parseDate(expenseDetails?.exp_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right">{formatCurrency(expenseDetails?.surplus2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px', fontSize: '16px' }} align="left" ></TableCell>
                        <TableCell sx={{
                          background: parseDate(incomeDetails?.inc_date1) > parseDate(incomeDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="left" />
                        <TableCell sx={{
                          fontSize: '16px', background: parseDate(incomeDetails?.inc_date1) < parseDate(assetDetails?.inc_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="left" />

                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
                <Box sx={{ mt: 2.5 }}>
                  <ParagraphComp text='Receipts and Payments Account (all figures are in ₹)' className='text-[#004878] text-2xl mb-3 font-bold' />
                  <Table aria-label="collapsible table">
                    <TableHead sx={{ background: '#EDF2F6' }}>
                      <TableRow>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Receipts for the year ended on</TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px', background: '#EDF2F6' }} align="right">{receiptDetails?.rec_date1}  <span> (₹)</span></TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="right">{receiptDetails?.rec_date2}  <span> (₹)</span></TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Payments for the year ended on</TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="right">{paymentDetails?.pay_date1}  <span> (₹)</span></TableCell>
                        <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="right">{paymentDetails?.pay_date2}  <span> (₹)</span></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell align="left" sx={{ color: 'black', fontWeight: 600, fontSize: '16px' }}>Opening Cash and Bank Balance</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.opening_balance1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.opening_balance2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Capital items/ assets purchased for the organisation</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.capital_for_org1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.capital_for_org2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Earned/ Self-generated income</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.earned_income1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.earned_income2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Capital items/ assets purchased for beneficiaries</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.capital_for_beneficiaries1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.capital_for_beneficiaries2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Donations from Indian sources</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.donations_indians1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.donations_indians2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Purchase of investments</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.purchase_investment1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.purchase_investment2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Grants from Indian sources (including CSR)</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.grants_indians1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.grants_indians2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Grants/ donations to other organisations</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.grants1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.grants2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Donations from International sources</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.donations_internationals1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.donations_internationals2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Loans and advances</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.loans_adv1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.loans_adv2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Grants from International sources</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.grants_international1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.grants_international2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Other Payments</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.other_payments1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.other_payments2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Sale of investments/ assets</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.sale_investment1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.sale_investment2 || '-')}</TableCell>
                        <TableCell align="left" sx={{ color: 'black', fontSize: '16px', fontWeight: 600 }}>Total Payments</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.total_payments1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.total_payments2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Loans</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.loans1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.loans2 || '-')}</TableCell>
                        <TableCell align="left" sx={{ color: 'black', fontWeight: 600, fontSize: '16px' }}>Closing Cash &Bank Balance</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.closing_cash1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(paymentDetails?.closing_cash2 || '-')}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: '16px' }} align="left" >Other receipts</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.other_receipts1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.other_receipts2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" />
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{ }</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{ }</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left" sx={{ color: 'black', fontWeight: 600, fontSize: '16px' }}>Total Receipts</TableCell>
                        <TableCell sx={{
                          background: parseDate(receiptDetails?.rec_date1) > parseDate(receiptDetails?.rec_date2)
                            ? '#EDF2F6'
                            : 'inherit', fontSize: '16px'
                        }} align="right" >{formatCurrency(receiptDetails?.total_receipts1 || '-')}</TableCell>
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(receiptDetails?.rec_date2) > parseDate(receiptDetails?.rec_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="right" >{formatCurrency(receiptDetails?.total_receipts2 || '-')}</TableCell>
                        <TableCell sx={{ fontSize: '16px' }} align="left" />
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date1) > parseDate(paymentDetails?.pay_date2)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="left" />
                        <TableCell sx={{
                          fontSize: '16px',
                          background: parseDate(paymentDetails?.pay_date2) > parseDate(paymentDetails?.pay_date1)
                            ? '#EDF2F6'
                            : 'inherit',
                        }} align="left" />
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box >
                <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', mt: 2 }}>
                  <ParagraphComp text={'For the financial year 2022-2023, date of filing Statutory Returns'} className='text-[#004878] text-2xl font-bold mb-2' />
                  <Box sx={{ display: 'flex' }}>
                    <ParagraphComp text='Income Tax Return: &nbsp; ' className='text-[#004878] text-md font-bold' />
                    <ParagraphComp className='text-[#004878] text-md font-normal' >
                      {financialDetails?.financials?.[6]?.income_tax_return}
                    </ParagraphComp>
                  </Box>
                  <Box sx={{ display: 'flex', mt: .5 }}>
                    <ParagraphComp text='FCRA Return:&nbsp; ' className='text-[#004878] text-md font-bold' />
                    <ParagraphComp text={financialDetails?.financials?.[7]?.fcra_return} className='text-[#004878] text-md font-normal' />
                  </Box>
                  <Box sx={{ display: 'flex', mt: .5 }}>
                    <ParagraphComp text='Trust/ Society/ Company Annual Return:&nbsp;' className='text-[#004878] text-md font-bold' />
                    <ParagraphComp text='' className='text-[#004878] text-md font-normal' />
                  </Box>
                </Box>
              </Box >}
            </>
            :
            <ParagraphComp text='No data provided for this section.' className='text-[black] text-xl mt-[20px] font-thin' />
        }
      </div >

    </>
  )
}
